export const DROPDOWN_OPTIONS = {
  squareFeet: [
    { id: 'no-min', label: 'No Min' },
    { id: '1000', label: '1,000' },
    { id: '1500', label: '1,500' },
    { id: '2000', label: '2,000' },
    { id: '2500', label: '2,500' },
    { id: '3000', label: '3,000' },
    { id: '4000', label: '4,000' },
    { id: '5000', label: '5,000' },
    { id: '6000', label: '6,000' },
    { id: '7500', label: '7,500' },
    { id: '10000', label: '10,000' },
    { id: 'no-max', label: 'No Max' }
  ],
  lotSize: [
    { id: 'no-min', label: 'No Min' },
    { id: '0.25', label: '0.25 acres' },
    { id: '0.5', label: '0.5 acres' },
    { id: '1', label: '1 acre' },
    { id: '2', label: '2 acres' },
    { id: '5', label: '5 acres' },
    { id: '10', label: '10 acres' },
    { id: 'no-max', label: 'No Max' }
  ],
  yearBuilt: [
    { id: 'no-min', label: 'No Min' },
    { id: '1850', label: '1850' },
    { id: '1900', label: '1900' },
    { id: '1950', label: '1950' },
    { id: '1970', label: '1970' },
    { id: '1980', label: '1980' },
    { id: '1990', label: '1990' },
    { id: '2000', label: '2000' },
    { id: '2005', label: '2005' },
    { id: '2010', label: '2010' },
    { id: '2015', label: '2015' },
    { id: '2020', label: '2020' },
    { id: 'no-max', label: 'No Max' }
  ],
  waterView: [
    { id: 'any', label: 'Any' },
    { id: 'Oceanfront', label: 'Oceanfront' },
    { id: 'Oceanview', label: 'Oceanview' },
    { id: 'Waterfront', label: 'Waterfront' },
    { id: 'Waterview', label: 'Waterview' },
    { id: 'Bayfront', label: 'Bayfront' },
    { id: 'Bayview', label: 'Bayview' },
    { id: 'Pondfront', label: 'Pondfront' },
    { id: 'Pondview', label: 'Pondview' },
    { id: 'Harborfront', label: 'Harborfront' },
    { id: 'Harborview', label: 'Harborview' },
    { id: 'Lakefront', label: 'Lakefront' },
    { id: 'Lakeview', label: 'Lakeview' },
    { id: 'Creek/Inletfront', label: 'Creek/Inletfront' },
    { id: 'Creek/Inletview', label: 'Creek/Inletview' },
    { id: 'Canalfront', label: 'Canalfront' },
    { id: 'Canalview', label: 'Canalview' },
    { id: 'Soundfront', label: 'Soundfront' },
    { id: 'Soundview', label: 'Soundview' }
  ],
  listingStatus: [
    { id: 'for-sale', label: 'For Sale' },
    { id: 'in-contract', label: 'In Contract' },
    { id: 'offer-and-acceptance', label: 'Offer & Acceptance' },
    { id: 'off-the-market', label: 'Off Out East' },
    { id: 'sold', label: 'Sold' }
  ],
  rentalStatus: [
    { id: 'active', label: 'Active' },
    { id: 'inactive', label: 'Inactive' },
    { id: 'rented', label: 'Rented' }
  ],
  pricePerSqFt: [
    { id: 'no-min', label: 'No Min' },
    { id: '200', label: '$200' },
    { id: '300', label: '$300' },
    { id: '400', label: '$400' },
    { id: '500', label: '$500' },
    { id: '600', label: '$600' },
    { id: '750', label: '$750' },
    { id: '1000', label: '$1,000' },
    { id: '1250', label: '$1,250' },
    { id: '1500', label: '$1,500' },
    { id: '2000', label: '$2,000' },
    { id: '2500', label: '$2,500' },
    { id: 'no-max', label: 'No Max' }
  ],
  openHouse: [
    { id: 'any', label: 'Any' },
    { id: 'today', label: 'Today' },
    { id: 'tomorrow', label: 'Tomorrow' },
    { id: 'next-2-days', label: 'In the next 2 days' },
    { id: 'next-4-days', label: 'In the next 4 days' },
    { id: 'next-7-days', label: 'In the next 7 days' }
  ],
  postedBy: [
    { id: 'any', label: 'Any' },
    { id: 'agent', label: 'Agent' },
    { id: 'owner', label: 'Owner' }
  ]
}

export const CHECKBOX_GROUPS = {
  propertyType: [
    { name: 'newConstruction', label: 'New construction', icon: 'new-construction' },
    { name: 'singleStory', label: 'Single-story', icon: 'single-story' },
    { name: 'South of Highway', label: 'South of highway', icon: 'south-highway' }
  ],
  basicAmenities: [
    { name: 'Pool', label: 'Pool', icon: 'pool' },
    { name: 'Tennis', label: 'Tennis court', icon: 'tennis' },
    { name: 'Sauna', label: 'Sauna', icon: 'sauna' },
    { name: 'Hot Tub', label: 'Hot tub/Jacuzzi', icon: 'hot-tub' },
    { name: 'Linens', label: 'Linens', icon: 'linens' }
  ],
  indoorAmenities: [
    { name: 'Central AC', label: 'Central AC', icon: 'central-ac' },
    { name: 'Security System', label: 'Security system', icon: 'security-system' },
    { name: 'Basement', label: 'Basement', icon: 'basement' },
    { name: 'TV/Cable/Satellite', label: 'TV/Cable/Satellite', icon: 'tv-cable' },
    { name: 'Handicap Features', label: 'Handicap access', icon: 'handicap' },
    { name: 'Exercise Room', label: 'Gym', icon: 'gym' },
    { name: 'Laundry Room', label: 'Laundry Room', icon: 'laundry' },
    { name: 'Fireplace', label: 'Fireplace', icon: 'fireplace' }
  ],
  outdoorAmenities: [
    { name: 'Outdoor Shower(s)', label: 'Outdoor shower', icon: 'outdoor-shower' },
    { name: 'waterAccess', label: 'Water access', icon: 'water-access' },
    { name: 'Beach Rights', label: 'Beach rights', icon: 'beach-rights' },
    { name: 'Dock', label: 'Dock', icon: 'dock' },
    { name: 'Sprinkler System', label: 'Sprinkler system', icon: 'sprinkler' },
    { name: 'Pool/Guest House', label: 'Guest house', icon: 'guest-house' }
  ],
  roomAmenities: [
    { name: 'Bonus Room', label: 'Bonus room' },
    { name: 'Breakfast Area', label: 'Breakfast area' },
    { name: 'Family Room/Den', label: 'Family room/Den' },
    { name: 'Great Room', label: 'Great room' },
    { name: 'Library', label: 'Library' },
    { name: 'Loft', label: 'Loft' },
    { name: 'Media Room', label: 'Media room' },
    { name: 'Office', label: 'Office' },
    { name: 'Studio', label: 'Studio' },
    { name: 'Study', label: 'Study' }
  ],
  communityAmenities: [
    { name: 'Gated Community', label: 'Gated community' },
    { name: 'Community Pool', label: 'Community pool' },
    { name: 'Community Tennis', label: 'Community tennis' },
    { name: 'Golf Course', label: 'Golf course' },
    { name: 'Clubhouse/Recreation', label: 'Clubhouse/Recreation' },
    { name: 'Docking Rights', label: 'Docking rights' }
  ],
  houseRules: [
    { name: 'Pets Allowed', label: 'Pets allowed', icon: 'pets-allowed' },
    { name: 'Smoking Allowed', label: 'Smoking allowed', icon: 'smoking-allowed' }
  ]
}

export const HISTOGRAM_CONFIG = {
  MAX_HEIGHT: 80,
  MIN_HEIGHT: 5,
  BAR_SPACING: 0.8,
  MIN_BAR_WIDTH: 2
}